module.exports = __webpack_public_path__ + "img/logo-parte2.dfb243a6.png";